// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Luna Point 2
 * Service Luna Point 2
 * Version: v.0.0.0
 */
/**
 * The `"null"` literal - matches objects whose corresponding field is not
 * set or was not estimated.
 */
export type NullFilter = typeof NullFilter[keyof typeof NullFilter];


export const NullFilter = {
  null: 'null',
} as const;
